import produce from 'immer';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, CentralLiberacao } from './types';

export const INITIAL_STATE: CentralLiberacao = {
	status: 0,
	resultado: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): CentralLiberacao {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ENVIA_CENTRAL_LIBERACAO: {
				break;
			}

			case Types.ENVIA_CENTRAL_LIBERACAO_SUCCESS: {
				draft.status = 200;
				draft.resultado = action.payload;
				break;
			}

			case Types.ENVIA_CENTRAL_LIBERACAO_FAILURE: {
				draft.status = 400;
				draft.resultado = INITIAL_STATE.resultado;
				break;
			}

			case Types.ENVIA_CENTRAL_LIBERACAO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.resultado = INITIAL_STATE.resultado;
				break;
			}

			default:
		}

		return draft;
	});
}
